import { useEffect, useState } from "react";

const API = "https://rbhardwaj.com/formapi.php";

export default function UserForm() {
  const [users, setUsers] = useState([]);
  const [editId, setEditId] = useState(null);

  const emptyForm = {
    name: "",
    fathername: "",
    dob: "",
    address: "",
    state: "",
    mobile: "",
    email: "",
    finance_bank: "",
    loan_amount: "",
    password: "",
  };

  const [form, setForm] = useState(emptyForm);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // 🔐 Random password generator
  const generatePassword = (length = 8) => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$!";
    let password = "";
    for (let i = 0; i < length; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  };

  const loadUsers = async () => {
    const res = await fetch(`${API}?action=read`);
    setUsers(await res.json());
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const submitForm = async (e) => {
    e.preventDefault();

    let payload = { ...form };

    // ✅ generate password only on create
    if (!editId) {
      payload.password = generatePassword();
      console.log("Generated Password:", payload.password); // optional
    }

    const action = editId ? "update" : "create";

    await fetch(`${API}?action=${action}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(editId ? { ...payload, id: editId } : payload),
    });

    setForm(emptyForm);
    setEditId(null);
    loadUsers();
  };

  const editUser = (user) => {
    setForm({
      name: user.name || "",
      fathername: user.fathername || "",
      dob: user.dob || "",
      address: user.address || "",
      state: user.state || "",
      mobile: user.mobile || "",
      email: user.email || "",
      finance_bank: user.finance_bank || "",
      loan_amount: user.loan_amount || "",
      password: "",
    });
    setEditId(user.id);
  };

  const deleteUser = async (id) => {
    await fetch(`${API}?action=delete`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });
    loadUsers();
  };

  return (
    <div style={{ padding: "30px",backgroundColor:"white",maxWidth:'1000px',width:'90%',borderRadius:"10px",margin:'30px auto' }}>
      <h2 style={{ textAlign: "center",margin:'10px auto' }}>
        {editId ? "Update User" : "Application form"}
      </h2>

      <form
        onSubmit={submitForm}
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          justifyContent: "center",
          
     
        }}
      >
        {Object.keys(emptyForm).map(
          (key) =>
            key !== "password" &&
            key !== "dob" && (
              <div className="formlabeldiv" key={key}>
           
                <input
                  name={key}
               
                  value={form[key]}
                  onChange={handleChange}
                />
                     <label> {key.replaceAll("_", " ").toUpperCase()}</label>
              </div>
            )
        )}

        {/* DOB */}
        <div className="formlabeldiv">
          <input
            type="date"
            name="dob"
            value={form.dob}
            onChange={handleChange}
          />
             <label> Date of Birth</label>
        </div>

        <button type="submit" style={{maxWidth:'300px',width:'100%'}}>{editId ? "Update" : "Submit"}</button>
      </form>
    </div>
  );
}
